import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock } from 'lucide-react';
export function PricingSection() {
  return <section className="w-full bg-motor-black py-14 px-4 sm:px-6 lg:px-8 carbon-texture" data-id="element-135">
      <div className="max-w-2xl mx-auto" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-gray-900 to-gray-800 border-4 border-motor-red rounded-2xl p-6 sm:p-8 shadow-red-glow-lg" data-id="element-137">
          <div className="text-center space-y-5" data-id="element-138">
            <div className="inline-flex items-center gap-2 bg-motor-red/20 border border-motor-red px-4 py-2 rounded-full" data-id="element-139">
              <Clock className="w-4 h-4 text-motor-red" data-id="element-140" />
              <span className="font-bebas text-lg text-motor-red uppercase tracking-wider" data-id="element-141">
                Oferta por tiempo limitado
              </span>
            </div>

            <div className="space-y-2" data-id="element-142">
              <span className="font-montserrat text-2xl text-gray-500 line-through block" data-id="element-143">
                $49.990
              </span>
              <span className="font-bebas text-6xl sm:text-7xl text-motor-red block" data-id="element-144">
                $19.990
              </span>
              <p className="text-gray-400 font-montserrat text-base" data-id="element-145">
                Pago único • Acceso de por vida
              </p>
            </div>

            <motion.a href="https://checkout.tusbeneficios.shop/cart/50954760650985:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05,
            boxShadow: '0 0 50px rgba(225, 6, 0, 0.7)'
          }} whileTap={{
            scale: 0.95
          }} className="w-full sm:w-auto bg-motor-red text-white font-bebas text-2xl px-10 py-4 rounded-full uppercase tracking-wider shadow-red-glow hover:bg-red-700 transition-all duration-300 flex items-center justify-center gap-3 group mx-auto no-underline" data-id="element-146">
              QUIERO ACCEDER AHORA
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-147" />
            </motion.a>

            <div className="pt-4 border-t border-gray-700" data-id="element-148">
              <p className="text-gray-400 font-montserrat text-xs" data-id="element-149">
                ✓ Descarga inmediata • ✓ Garantía de 7 días • ✓ Soporte incluido
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}